import { api } from "../DefaultService";
import type { IPaginationParams } from "../types";
import type {
	IStudentCreateParams,
	IStudentFilterProps,
	IStudentProps,
	IStudentSimpleProps,
	IStudentUpdateParams,
} from "./types";

const ENDPOINT = "v1/student";

export const createStudentAsync = async ({
	data,
	imageFile,
}: IStudentCreateParams): Promise<IStudentProps> => {
	data.imageFile = imageFile;
	return await api
		.post(ENDPOINT, data, {
			headers: { "Content-Type": "multipart/form-data" },
		})
		.then((response) => response.data)
		.catch((error) => {
			throw new Error(
				error?.response?.data?.message || "Erro interno do servidor!",
			);
		});
};

export const getStudentByIdAsync = async (
	id: number,
): Promise<IStudentProps> => {
	return await api
		.get(`${ENDPOINT}/${id}`)
		.then((response) => response.data)
		.catch((error) => {
			throw new Error(
				error?.response?.data?.message || "Erro interno do servidor!",
			);
		});
};

export const getAllStudentByLicenseAsync = async (
	pagination?: IPaginationParams,
	filter?: IStudentFilterProps,
): Promise<IStudentSimpleProps[]> => {
	const search = filter?.search ?? filter?.name;

	return await api
		.get(`${ENDPOINT}/getAllByLicense`, {
			params: {
				...pagination,
				search,
				cpf: filter?.cpf,
				registration: filter?.registration,
			},
		})
		.then((response) => response.data)
		.catch((error) => {
			throw new Error(
				error?.response?.data?.message || "Erro interno do servidor!",
			);
		});
};

export const getAllStudentCountByLicenseAsync = async (
	filter?: IStudentFilterProps,
): Promise<number> => {
	return await api
		.get(`${ENDPOINT}/getAllByLicense/count`, {
			params: { ...filter },
		})
		.then((response) => response.data)
		.catch((error) => {
			throw new Error(
				error?.response?.data?.message || "Erro interno do servidor!",
			);
		});
};

export const getAllStudentPresenceInSchoolAsync = async (
	filter?: IStudentFilterProps,
): Promise<{
	inside: IStudentSimpleProps[];
	outside: IStudentSimpleProps[];
}> => {
	return await api
		.get(`${ENDPOINT}/presence`, {
			params: { ...filter },
		})
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			throw new Error(
				error?.response?.data?.message || "Erro interno do servidor!",
			);
		});
};

export const updateStudentAsync = async ({
	id,
	data,
	imageFile,
}: IStudentUpdateParams): Promise<IStudentProps> => {
	data.imageFile = imageFile;
	return await api
		.put(`${ENDPOINT}/${id}`, data, {
			headers: { "Content-Type": "multipart/form-data" },
		})
		.then((response) => response.data)
		.catch((error) => {
			throw new Error(
				error?.response?.data?.message || "Erro interno do servidor!",
			);
		});
};

export const deleteStudentAsync = async (id: number): Promise<void> => {
	await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
		throw new Error(
			error?.response?.data?.message || "Erro interno do servidor!",
		);
	});
};
